export class AzureSqlDatabaseRestoreDestination {
    'azureSqlDatabase';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azureSqlDatabase",
            "baseName": "azureSqlDatabase",
            "type": "AzureSqlDatabaseRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlDatabaseRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
